import { defineMessages } from 'react-intl';

export const ServiceInspection = defineMessages({
  title: {
    id: 'app.InstallationTechnologyStepContent.title',
    defaultMessage: 'Identifikované měřidlo',
  },
  strapiId: {
    id: 'app.common.strapiId',
    defaultMessage: 'StrapiId',
  },
  sn: {
    id: 'app.common.sn',
    defaultMessage: 'SN',
  },
  headerContent: {
    id: 'app.ServiceInspection.headerContent',
    defaultMessage: 'Servisní úkon',
  },
  recordSentSuccess: {
    id: 'app.common.recordSentSuccess',
    defaultMessage: 'Záznam byl úspěšně odeslán',
  },
  recordSentError: {
    id: 'app.common.recordSentError',
    defaultMessage: 'Při odesílání záznamu došlo k chybě',
  },
  placementOverviewPhotos: {
    id: 'app.ServiceInspection.placeOverviewPhotos',
    defaultMessage: 'Fotodokumentace',
  },
  placementOverviewPhotosRequired: {
    id: 'app.ServiceInspection.placeOverviewPhotosRequired',
    defaultMessage: 'Vyplňte prosím fotodokumentaci po servisním úkonu!',
  },
  note: {
    id: 'app.ServiceInspection.note',
    defaultMessage: 'Poznámka',
  },
  notePlaceholder: {
    id: 'app.ServiceInspection.notePlaceholder',
    defaultMessage: 'Je třeba speciálního vybavení! Nachází se ve stísněné šachtě!',
  },
  confirm: {
    id: 'app.common.confirm',
    defaultMessage: 'Potvrdit',
  },
  register: {
    id: 'app.common.register',
    defaultMessage: 'Register',
  },
  registerStatus: {
    id: 'app.common.registerStatus',
    defaultMessage: 'Stav registru',
  },
  registerRequired: {
    id: 'app.common.registerRequired',
    defaultMessage: 'Zadejte stav registru',
  },
  registerPhotos: {
    id: 'app.common.registerPhotos',
    defaultMessage: 'Fotky odečtu registru',
  },
});
